import React, { useState, useEffect } from "react";
import styled from '@emotion/styled';
import axios from 'axios'
import Pixel from '../modules/Pixel'
import Modal from 'react-modal';
import { trackCustomEvent } from 'gatsby-plugin-google-analytics'

interface SubscribeFormProps {
  isInsta?: boolean
}


const SubscribeForm: React.FC<SubscribeFormProps> = ({ isInsta = false }) => {
  const [email, setEmail] = useState('');
  const [nickname, setNickname] = useState('');
  const [validation, setValidation] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const submit = async () => {
    if (validation) {
      try {
        const requestParams: any = {
          mode: 'no-cors',
          method: 'POST',
          url: 'https://stibee.com/api/v1.0/lists/SX3WYbgk6crCXkvHgg8sHLNSprHz/public/subscribers',
          params: {
            email,
            nickname,
          }
        };
        await axios(requestParams)
        Pixel.track("Donate")
        trackCustomEvent({
          category: "Subscribe Complete",
          action: "subscribe"
        })
        setModalIsOpen(true)
      }
      catch (e) {
        alert("입력한 정보를 확인 후 다시 시도해주세요.")
        console.error(e)
      }
    }
  }

  function validateEmail(email: string) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  const insta = () => {
    window.location.href = "https://www.instagram.com/tickletter_official/"
  }

  const shareFriends = () => {
    const shareUrl = "http://link.tickleinvest.com/subscribewithmee";
    const shareText = "🙆‍♀️친구야! 티클레터 같이 보자🙆‍♀️\n" + shareUrl;

    if (navigator.share) {
      navigator.share({
        title: document.title,
        text: '🙆‍♀️친구야! 티클레터 같이 보자🙆‍♀️',
        url: shareUrl
      }).then(() => { })
        .catch(console.error);
    } else {
      if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(shareText);
        return;
      }
      navigator.clipboard.writeText(shareText).then(function () {
        alert("링크가 복사되었습니다!");
      }, function (err) {
        console.error('Async: Could not copy text: ', err);
      });
    }
    setModalIsOpen(false)
  }

  function fallbackCopyTextToClipboard(text: string) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      alert("링크가 복사되었습니다!");
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
  }

  useEffect(() => {
    if (
      email.length > 0 &&
      validateEmail(email) &&
      nickname.length > 0
    ) {
      setValidation(true)
    }
    else {
      setValidation(false)
    }
  }, [email, nickname])


  return (
    <>
      <InputGroup>
        <TextInput
          type="email"
          placeholder="이메일 주소를 입력해주세요"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />
        <TextInput
          type="text"
          placeholder="닉네임을 입력해주세요"
          onChange={(event) => {
            setNickname(event.target.value);
          }}
          value={nickname}
        />
        <PrivacyText>
          구독하기 버튼을 누르면{' '}
          <PrivacyLink href="https://tickle-public.s3.ap-northeast-2.amazonaws.com/terms/tickle_letter_3rd_privacy.pdf" target="_blank">
            개인정보수집 이용약관
          </PrivacyLink>
          에 동의합니다
        </PrivacyText>
        <ButtonGroup>

          <Submit onClick={submit} isInsta={isInsta}>티클레터 구독하기</Submit>
          {isInsta ? (
            <InstaButton onClick={insta}>
              <InstaIcon src={require("../content/img/insta.png")} />
            </InstaButton>
          ) : null}
        </ButtonGroup>
      </InputGroup>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        contentLabel="Example Modal"
        style={customStyles}
      >
        <ModalBody>
          <ModalTitle>
            티클레터를 구독해주셔서 감사해요!
          </ModalTitle>
          <ModalContent>
            주변에도 경제뉴스를 어려워하는
            친구가 있지 않나요? 공유 링크를
            복사하고, 친구에게 알려줘봐요!
          </ModalContent>
        </ModalBody>
        <ModalButtonGroup>
          <ModalCancel onClick={() => setModalIsOpen(false)}>닫기</ModalCancel>
          <ModalConfirm onClick={shareFriends}>친구에게 알리기</ModalConfirm>
        </ModalButtonGroup>
      </Modal>
    </>
  )
}

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  
`;

const TextInput = styled.input`
  width: 324px;
  padding: 13px 16px;
  border-radius: 5px;
  border: solid 1px #ab4900;
  background-color: #ffffff;
  font-size: 16px;
  margin-bottom: 8px;
  color: #000; 
  @media  (min-width: 320px) and (max-width: 767px) {
    width: 100%; 
  }

`;

const PrivacyText = styled.p`
  font-size: 12px;
  color: #979797;
`;

const PrivacyLink = styled.a`
  color: #ff9016;
  text-decoration: underline;
  text-decoration-color: #ff9016;
`;

const ButtonGroup = styled.div`
  display: flex;
`;

const Submit = styled.button<{ isInsta: boolean }>`
  width: ${props => props.isInsta ? '241px' : '100%'};
  height: 44px;
  text-align: center; 
  line-height: 0px;
  border-radius: 10px;
  padding: 13px 0;
  font-size: 12px; 
  font-weight: bold;
  margin: 0;
  color: #fff;
  background-color: #ff9016;
  @media  (min-width: 320px) and (max-width: 767px) {
    /* width: 100% - 5vw;  */
    flex: 1;
  }
`;

const InstaButton = styled.button`
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background-color: #fff7ee;
  margin-left: 8px; 
  padding: 0;
`;

const InstaIcon = styled.img`
  width: 26px;
  height: 26px;
`;

const ModalBody = styled.div`
  padding: 24px 48px;
  @media  (min-width: 320px) and (max-width: 767px) {
    padding: 16px 33px;
  }
`;

const ModalTitle = styled.div`
  width: 100%;
  font-size: 21px;
  font-weight: bold;
  text-align: center;
  margin: 0 auto;
  margin-bottom: 24px;
  @media  (min-width: 320px) and (max-width: 767px) {
    width: 177px;
    font-size: 18px;
    margin-bottom: 16px;
  }
`;

const ModalContent = styled.div`
  width: 400px;
  font-size: 18px;
  text-align: center;
  font-weight: normal;
  margin: 0 auto;
  @media  (min-width: 320px) and (max-width: 767px) {
    width: 200px;
    font-size: 15px;
  }
`;

const ModalButtonGroup = styled.div`
  display: flex;
  height: 53px;
  border-top: solid 0.5px #e9e9e9;
  align-items: center;
  justify-content: center;
`;

const ModalConfirm = styled.button`
  flex: 1;
  font-weight: bold;
  background-color: #ffffff;
  color: #ff9016;
  font-size: 15px;
  &:focus {
    outline: none;
  }
`;

const ModalCancel = styled.button`
  flex: 1;
  font-weight: bold;
  background-color: #ffffff;
  color: #979797;
  font-size: 15px;
  &:focus {
    outline: none;
  }
`;

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: 0,
    borderRadius: 10,
    borderWidth: 0
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.3)'
  }
};

export default SubscribeForm;